<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import DanhSachKhachNhan from "@/components/customers/khach-hang-nhan";
import moment from "moment-timezone";

let user = JSON.parse(localStorage.getItem("user"));

export default {
  page: {
    title: "Quản lý khách hàng",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DanhSachKhachNhan },
  data() {
    return {
      columns: [
        { label: "Người gửi", field: "name" ,  width: "240px"},
        { label: "Điện thoại", field: "phone" ,  width: "140px"},
        { label: "Email", field: "email",  width: "140px" },
        { label: "Địa chỉ", field: "address" },
        { label: "Người nhận", field: "_id",  width: "120px" },
      ],
      rows: [],
      totalRows: 0,
      page: 1,
      perPage: 20,
      searchTerm: "",
      isLoading: false,
    };
  },
  methods: {
    async fetchCustomers() {
      try {
        this.isLoading = true;
        const { data } = await axios.post(
          process.env.VUE_APP_SERVER_URL + `/api/customers`,
          {
            page: this.page,
            limit: this.perPage,
            search: this.searchTerm,
          },
          {
            headers: { authorization: user.token },
          }
        );

        // Dữ liệu trả về phải là { items, total, page, limit }
        this.rows = data.items || [];
        this.totalRows = data.total || 0;
      } catch (error) {
        console.error("Lỗi tải khách hàng:", error);
      } finally {
        this.isLoading = false;
      }
    },

    onPageChange(params) {
      this.page = params.currentPage;
      this.fetchCustomers();
    },

    onPerPageChange(params) {
      this.perPage = params.currentPerPage;
      this.page = 1;
      this.fetchCustomers();
    },

    onSearch(params) {
      this.searchTerm = params.searchTerm;
      this.page = 1;
      this.fetchCustomers();
    },
  },

  async mounted() {
    if (user) await this.fetchCustomers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader title="Quản lý khách hàng" />
    <div class="card">
      <div class="card-body">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :total-rows="totalRows"
          :pagination-options="{
            enabled: true,
            rowsPerPageLabel: 'các mục trong trang',
            nextLabel: 'tiếp',
            prevLabel: 'trước',
            mode: 'records',
            perPage: perPage,
            perPageDropdown: [10, 20, 50],
            allLabel: 'Tất cả',
          }"
          :line-numbers="true"
          :search-options="{ enabled: true }"
          mode="remote"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          @on-search="onSearch"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === '_id'">
              <DanhSachKhachNhan :customer="props.row" />
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </Layout>
</template>
